import React, { useRef } from "react";
import { premierScore } from "../../helpers/suivreListe";
import { ChoixMailResultat } from "./ChoixMailResultat";
import styles from "./GrilleEnregistree.module.css";

/**
 * Confirmation d'une grille enregistrée (premier écran, Mes grilles, liste suivie), suivie du
 * choix du mail de résultat quand aucun canal n'est actif et que le compte ne l'a pas déjà refusé.
 */
export function GrilleEnregistree({
  nom,
  numeros,
  notification,
  mailRefuse = false,
  remplace,
  onChoisi,
}: {
  nom: string;
  /** Version précédente de la même liste, remplacée par celle-ci. */
  remplace?: string | null;
  numeros?: number[];
  /** Réglage myDrawNotification du compte : le choix n'est proposé que s'il vaut « none ». */
  notification: string | null | undefined;
  /** « Non merci » déjà répondu sur ce compte (mailResultatRefuse) : la question n'est plus posée. */
  mailRefuse?: boolean;
  onChoisi?: (canal: "email" | "none") => void;
}) {
  // Choix proposé dès qu'aucun canal n'est actif, puis gardé affiché : après « Oui, par mail », le
  // réglage relu vaut « email » et la phrase de confirmation doit rester visible.
  const proposer = useRef(false);
  if ((notification ?? "none") === "none" && !mailRefuse) proposer.current = true;

  return (
    <div className={styles.bloc}>
      <p className={styles.ok} role="status">
        Votre grille <strong>« {nom} »</strong> est enregistrée. Premier score {premierScore()}, après le tirage de 20 h.
        {remplace && <> Elle remplace « {remplace} », la sélection d'un tirage précédent.</>}
      </p>
      {numeros && numeros.length > 0 && (
        <p className={styles.boules} aria-label={`Numéros : ${numeros.join(", ")}`}>
          {numeros.map((n) => <span key={n} aria-hidden="true">{n}</span>)}
        </p>
      )}
      {proposer.current && <ChoixMailResultat onChoisi={onChoisi} />}
    </div>
  );
}
